<template>
    <div>
        <main class="tw-relative">
            <div class="container">
                <div class="tw-flex tw-flex-col lg:tw-flex-row">
                    <div class="text tw-flex-1 lg:tw-px-0">
                        <img src="~@/assets/img/logo.svg" alt="Dish by Makro" class="logo tw-px-4">
                        <div class="promo">
                            <div>
                                <h2>
                                  Adira às<br>
                                  <span>ferramentas DISH</span><br>
                                  e descubra as<br>
                                  vantagens<br>
                                  para o seu negócio
                                </h2>
                            </div>
<!--                            <div>-->
<!--                                <h2>-->
<!--                                    <span>Adira ao DISH Profissional <br>e veja as vantagens</span>-->
<!--                                </h2>-->
                                <!-- <h2>
                                    • 1 mês grátis de subscrição<br>• 50€ de desconto no Marketplace*
                                </h2> -->
<!--                            </div>-->
                        </div>
                    </div>
                    <div class="form-container">
                        <Form v-if="!$store.state.formSuccess" class="lg:tw-mb-6" />
                        <FormSuccess v-if="$store.state.formSuccess" >
                            Thank you message
                        </FormSuccess>
                    </div>
                </div>
            </div>
        </main>
        <section class="bullets">
            <div class="tw-container tw-grid tw-grid-cols-1 lg:tw-grid-cols-5 tw-gap-10 lg:tw-gap-10">
              <div>
                <img src="~@/assets/img/icons/payments.svg" alt="World">
                <p>
                  Solução de <b>pagamentos
                  rápidos</b> e <b>seguros</b>
                </p>
              </div>
                <div>
                    <img src="~@/assets/img/icons/world.svg" alt="World">
                    <p>Garanta uma <b>presença online</b> para atrair mais clientes</p>
                </div>
                <div>
                    <img src="~@/assets/img/icons/sms.svg" alt="SMS">
                    <p>Reduza as não comparências com lembretes por <b>SMS e email</b></p>
                </div>
                <div>
                    <img src="~@/assets/img/icons/clock.svg" alt="Clock">
                    <p>Economize tempo na gestão das reservas, com <b>0% de comissão</b></p>
                </div>
                <div>
                    <img src="~@/assets/img/icons/calendar.svg" alt="Calendar">
                    <p>Os clientes podem reservar <b>24&nbsp;horas/7 dias</b> da semana </p>
                </div>
            </div>
        </section>
        <footer v-scroll-to="'form'" class="tw-container tw-flex tw-flex-col tw-gap-8 tw-items-center tw-text-center">
            <img src="~@/assets/img/makro.jpg" alt="Makro">
           <small>
            <!-- *O código de desconto no Marketplace é válido exclusivamente para a compra de produtos METRO. Para informações detalhadas entre em contacto connosco através do <a href="mailto:contacto.cliente@makro.pt"><u>contacto.cliente@makro.pt</u></a> -->
           </small>
        </footer>
    </div>
</template>
<script>
import Form from '@/components/FormTemporary.vue';
import FormSuccess from '@/components/FormSuccess.vue';

export default {
    name: 'Home',
    components: {
        Form,
        FormSuccess,
    },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/partials/variables";
@import "~@/assets/scss/partials/fonts";

main {
    @apply tw-bg-contain tw-bg-no-repeat tw-bg-left-top;
    position: relative;
    border-radius: 0 0 100px;
    background-image: url('~@/assets/img/temp_hero_mobile.png');

    @screen lg {
        @apply tw-bg-cover tw-bg-no-repeat tw-bg-right;
        background-image: url('~@/assets/img/temp_hero_img.png');
        padding-bottom: 50px;
        height: 750px;
    }

    .container {
        padding: 0px 0px 0px 0px;

        @screen lg {
            padding: 0 60px;
        }

        @screen xl {
            padding: 0 100px;
        }
    }

    .text {
        height: 436px;

        @screen lg {
            height: auto;
        }

        img {
            &.logo {
                margin-bottom: 0 !important;
                margin-top: 10px;
                max-width: 148.64px;

                @screen lg {
                    margin-top: 40px;
                    margin-bottom: 35px;
                    max-width: 236.53px;
                }
            }
        }

        .promo {
            padding-right: 40px;
            padding-top: 80px;

            @screen lg {
                @apply tw-absolute tw-left-0;
                padding-top: 120px;
                padding-right: 0px;
            }

            >div {

                &:first-of-type {
                    //background-color: rgba(#ED6938, .92);
                    border-top-right-radius: 22px;
                    padding-left: 20px;
                    padding-top: 20px;
                    padding-bottom: 20px;
                    max-width: fit-content;

                    @screen lg {
                        border-top-right-radius: 48px;
                        padding-left: 60px;
                        padding-top: 25px;
                        padding-bottom: 25px;
                        max-width: fit-content;
                    }

                    @screen xl {
                        padding-left: 120px;
                    }

                    h1 {
                        @apply tw-uppercase tw-font-bold tw-text-white;
                        font-family: $font-title;
                        font-size: 15px;
                        line-height: 19px;

                        @screen lg {
                            font-size: 22px;
                            line-height: 28px;
                        }
                    }
                }

                &:last-of-type {
                    //background-color: rgba(#1B3C7B, .92);
                    border-top-right-radius: 22px;
                    padding-left: 20px;
                    padding-right: 0px;
                    padding-top: 15px;

                    @screen lg {
                        border-top-right-radius: 48px;
                        padding-left: 60px;
                        padding-right: 0px;
                        padding-top: 45px;
                        padding-bottom: 45px;
                    }

                    @screen xl {
                        padding-left: 120px;
                    }

                    h2 {
                        @apply tw-uppercase tw-font-extrabold tw-pb-3;
                        font-family: $font-title;
                        color: #FFFFFF;
                        font-size: 18px;
                        line-height: 23px;

                        span {
                            color: $makro-blue;
                        }

                        @screen lg {
                            font-size: 24px;
                            line-height: 40px;

                            @screen lg {
                              font-size: 48px;
                              line-height: 54px;
                            }
                        }
                    }
                }
            }
        }
    }

    .form-container {
        @apply tw-w-full;
        margin-top: 0px;

        @screen lg {
            @apply tw-w-auto;
            margin-top: 0;
        }
    }
}

section.bullets {
    padding: 50px 0;

    @screen lg {
        padding: 75px 0;
    }

    img {
        @apply tw-mx-auto tw-mb-4;
    }

    p {
        @apply tw-text-center tw-text-base;

        color: $makro-blue;
    }
}

footer {
    img {
        width: 120px;
    }

    small {
        display: block;
        padding-bottom: 20px;
        width: 100%;
        color: #aaa;
        font-size: 9px;
    }
}
</style>
